import styled from "styled-components";

export const Container = styled.div`
  padding: 1%;
  background: #f5f5f5;
  font-size: 14px;

  @media (max-width: 800px) {
    padding: 5%;
  }
`;
export const Navigation = styled.div`
  display: flex;
  width: 25%;
  justify-content: space-between;

  a {
    text-decoration: none;
    color: black;
    margin: 0 5%;
  }

  @media (max-width: 800px) {
    display: block;
    width: 100%;
    margin: 5% 0;
    line-height: 3;
    font-size: 16px;
  }

  a {
    display: block;
  }
`;
export const SocialIcons = styled.div`
  width: 8%;
  color: black;
  a {
    margin: 0 5%;
    color: black;
  }

  @media (max-width: 800px) {
    width: 100%;
    margin: 5% 0;
  }
`;
export const Top = styled.div`
  display: flex;
  padding: 2%;
  padding-top: 5%;
  justify-content: space-between;

  @media (max-width: 800px) {
    display: block;
    padding-top: 8%;
    text-align: center;
  }
`;
export const Bottom = styled.div`
  text-align: center;
  padding: 0.2% 0;
`;
